import { TextField } from '@mui/material'
import { ActionsDialog } from '@src/components'
import { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditApplication } from '../../../data/types'

interface Props {
  open: boolean
  onClose: () => void
  app: CreditApplication
  handleAddingMessageToCreditApplication: (message: string) => void
}

const CreditApplicationMessageDialog = ({ open, onClose, app, handleAddingMessageToCreditApplication }: Props) => {
  const { t } = useTranslation()
  const [message, setMessage] = useState('')

  const handleCancel = () => {
    setMessage('')
    onClose()
  }

  const handleConfirm = () => {
    handleAddingMessageToCreditApplication(message)
    setMessage('')
  }

  return (
    <ActionsDialog
      open={open}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      disabled={message.trim().length === 0}
      title={`${t('common.application')} #${app.referenceNumber}`}
    >
      <TextField
        label={t('privateMessage.label')}
        type="text"
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        multiline
        rows={10}
        autoFocus
        style={{ width: 400 }}
        sx={{ mt: 1 }}
        slotProps={{ inputLabel: { shrink: true } }}
      />
    </ActionsDialog>
  )
}

export default memo(CreditApplicationMessageDialog)
